import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import CupRow from 'app/components/cup/CupRow';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {LOADING_MESSAGE, LoadingIndicator, Typography, SIZES} from '@fupa/fupa-uikit';
import {Subheading} from 'app/styles/heading';
import {useParams} from 'react-router';
import styled from 'styled-components';
import {CupOverviewPageReducer} from 'app/routes/cup/CupPageReducer';
import {fetchCupOverview, fetchCupOverviewRoundMatches, updateShow} from 'app/routes/cup/CupPageActions';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import StickyMobileBannerAdSlot from 'app/components/ads/StickyMobileBannerAdSlot';

const InfoWrapper = styled.div`
  padding: 0 ${SIZES[16]} ${SIZES[16]};
`;

const PreLineTypography = styled(Typography)`
  white-space: pre-line;
`;

const CupOverviewPage = ({defaultMeta, cupActive, cupInfo, dispatchRedux}) => {
  const {restoredData} = useRestoreData('CupOverviewPage');
  const {cupSlug, seasonSlug} = useParams();

  const initialState = restoredData ?? {
    isFetching: false,
    groups: [],
    details: {},
  };
  const [state, dispatch] = useReducer(CupOverviewPageReducer, initialState);

  const loadData = () => fetchCupOverview(cupSlug, seasonSlug, dispatchRedux)(dispatch, state);
  const loadMatches = groupSlug => fetchCupOverviewRoundMatches(cupSlug, seasonSlug, groupSlug)(dispatch, state);
  const setShow = (groupSlug, show) => dispatch(updateShow({groupSlug, show}));
  useFetchData(state, loadData, 'CupOverviewPage');

  const {groups, details, isFetching} = state;

  const robots = cupActive ? 'index, nofollow' : 'noindex, follow';
  const meta = [
    {name: 'description', content: defaultMeta},
    {name: 'robots', content: robots},
  ];

  const CupCategories = groups.map(round => {
    const GroupRows = round.groups.map(group => {
      const groupDetail = details[group.slug];
      return <CupRow key={group.slug} group={group} detail={groupDetail} loadMatches={loadMatches} setShow={setShow} />;
    });
    return (
      <React.Fragment key={round.cupCategory.slug}>
        <Subheading variant='subheading2'>{round.cupCategory.name}</Subheading>
        {GroupRows}
      </React.Fragment>
    );
  });

  const content = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor />
  ) : (
    <>
      {CupCategories}
      <Subheading variant='subheading2'>Turnierinfo</Subheading>
      <InfoWrapper>
        <PreLineTypography variant='caption1'>{cupInfo}</PreLineTypography>
      </InfoWrapper>
    </>
  );

  return (
    <>
      <ContentAdDesktop top='7.125rem' contentPaddingBottom={'4.5rem'}>
        <Helmet title='Spiele - ' meta={meta} />
        {content}
      </ContentAdDesktop>
      <StickyMobileBannerAdSlot />
    </>
  );
};

CupOverviewPage.propTypes = {
  defaultMeta: string.isRequired,
};

export default CupOverviewPage;
